import _ from "underscore";
import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import { actions } from "../../utils/overlay-store";
import Overlay from "./overlay";
import WindowOverflowMixin from "../../mixins/window-overflow-mixin";
import BasicUtils from "../../utils/basic-utils";

const DOM_PROPERTY_WHITELIST = ["height", "left", "scrollTop", "top", "width"];

export default class extends React.Component {
  static displayName = "Popover";

  static propTypes = {
    event: PropTypes.oneOf(["click", "hover"]),
    position: PropTypes.string,
    width: PropTypes.number,
    options: PropTypes.object,
    onClose: PropTypes.func,
  };

  static defaultProps = { event: "click" };
  state = { open: false };

  componentDidMount() {
    this.mounted = true;
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.open && this.state.open) {
      this.poller = setInterval(this.checkForOriginChange, 200);
    }
    if (this.state.open) {
      if (
        this.props.position !== prevProps.position ||
        this.props.width !== prevProps.width ||
        !_.isEqual(this.props.options, prevProps.options)
      ) {
        this.renderOverlay(this.props);
      }
    }
  }

  componentWillUnmount() {
    clearInterval(this.poller);
    this.mounted = false;

    if (this.state.overlay_key) {
      this.handleClose();
    }
  }

  checkForOriginChange = () => {
    if (this.mounted) {
      const node = this.domNode;
      if (node) {
        const dom_props = BasicUtils.pick(WindowOverflowMixin.getDOMProperties(node), DOM_PROPERTY_WHITELIST);
        const state_dom_props = BasicUtils.pick(this.state.dom_props, DOM_PROPERTY_WHITELIST);
        if (!_.isEqual(dom_props, state_dom_props)) {
          this.renderOverlay();
        }
      }
    }
  };

  handleClickToggle = e => {
    // _.defer is used to fix the bug where you "outside click"
    // but click on another popover, this prevents it
    // from showing and removing at once and breaking the component
    if (this.props.event === "click") {
      e.stopPropagation();
      if (!this.state.open) {
        _.defer(() => this.renderOverlay());
      }
    }
  };

  handleMouseOver = () => {
    if (this.props.event === "hover") {
      this.renderOverlay();
    }
  };

  handleMouseOut = () => {
    if (this.props.event === "hover") {
      this.handleClose();
    }
  };

  handleClose = () => {
    clearInterval(this.poller);
    if (this.mounted) {
      this.setState({ open: false });
    }
    actions.removeOverlay(this.state.overlay_key);
    this.props.onClose === "function" ? this.props.onClose() : undefined;
  };

  getOverlay = (dom_props, props) => {
    if (props == null) {
      ({ props } = this);
    }
    const attrs = _.extend(
      {},
      {
        position: props.position,
        width: props.width,
        origin: dom_props,
        arrowPosition: props.arrowPosition,
        onClose: () => _.defer(this.handleClose),
      },
      props.options
    );
    return <Overlay {...attrs}> {props.popoverContent()} </Overlay>;
  };

  renderOverlay = props => {
    if (props == null) {
      ({ props } = this);
    }
    if (props.disable) {
      return;
    }
    const dom_props = WindowOverflowMixin.getDOMProperties(this);
    const key = this.state.overlay_key || BasicUtils.randomKey();
    if (this.mounted) {
      this.setState({ open: true, dom_props, overlay_key: key });
    }
    actions.overlay(this.getOverlay(dom_props, props), _.extend(dom_props, { key }));
  };

  render() {
    return (
      <div
        ref={e => (this.domNode = e)}
        className={classNames("et--popover-trigger", this.props.className, {
          "is-open": this.state.open,
        })}
        role="button"
        tabIndex="0"
        style={this.props.style}
        onClick={this.handleClickToggle}
        onMouseEnter={this.handleMouseOver}
        onMouseLeave={this.handleMouseOut}
      >
        {this.props.children}
      </div>
    );
  }
}
